<template>
  <hm-content title="">
    <el-radio-group
      v-model="searchCondition.targetMode"
      size="small"
      @change="switchState"
    >
      <el-radio-button label="sale_amount">业绩目标配置</el-radio-button>
      <el-radio-button label="new_member">新客目标配置</el-radio-button>
    </el-radio-group>
    <div style="marginTop:50px" class="flex flex-between">
      <el-radio-group
        v-model="searchCondition.targetType"
        size="small"
        @change="switchState"
      >
        <el-radio-button label="year">年度目标配置</el-radio-button>
        <el-radio-button label="depart">多店目标配置</el-radio-button>
        <el-radio-button label="emp">员工目标配置</el-radio-button>
      </el-radio-group>
      <div v-if="searchCondition.targetType === 'depart'">
        <el-date-picker
          type="year"
          value-format="yyyy"
          v-model="searchCondition.targetYear"
          placeholder="请选择年份"
          size="small"
          class="mr10"
        >
        </el-date-picker>
        <el-cascader
          ref="cascader"
          clearable
          v-model="searchCondition.targetId"
          :props="props"
          :show-all-levels="false"
          size="small"
          placeholder="请选择机构"
          class="mr10"
        ></el-cascader>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <div v-if="searchCondition.targetType === 'emp'">
        <el-date-picker
          type="year"
          value-format="yyyy"
          v-model="searchCondition.targetYear"
          placeholder="请选择年份"
          size="small"
          class="mr10"
        >
        </el-date-picker>
        <el-cascader
          ref="cascader"
          v-model="searchCondition.empOrgCode"
          :props="props"
          :show-all-levels="false"
          size="small"
          clearable
          placeholder="请选择机构"
          class="mr10"
        ></el-cascader>
        <el-select
          size="small"
          clearable
          v-model="searchCondition.targetId"
          filterable
          class="mr10"
          placeholder="请选择导购"
        >
          <el-option
            :label="item.realname"
            :value="item.employeeId"
            v-for="(item, index) in employeeIdAllList"
            :key="index"
          ></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="mt20">
      <el-button type="primary" size="small" @click="add">新增目标</el-button>
    </div>
    <div>
      <ul class="results mt20">
        <li class="flex flex-wrap mb20" v-for="(v, i) in list" :key="i">
          <div class="results-header flex item-center flex-center">
            <div>
              <div
                class="results-title flex flex-center"
                v-if="searchCondition.targetType === 'depart'"
              >
                {{ v.departName }}
              </div>
              <div
                class="results-title flex flex-center"
                v-if="searchCondition.targetType === 'emp'"
              >
                {{ v.empDepartName }} {{ v.realname }}
              </div>
              <div class="results-title  flex flex-center">
                {{ v.targetYear }}年业绩目标
              </div>
              <div class="results-task">
                <span class="results-price">{{ v.totalValue }}</span
                >{{
                  searchCondition.targetMode === "sale_amount" ? "元" : "人"
                }}
              </div>
            </div>
          </div>
          <div class="results-month flex-1">
            <div class="flex flex-between item-center mb20">
              <div class="title">
                月度业绩目标
              </div>
              <div class="mr10">
                <el-button
                  size="small"
                  class="blue"
                  type="text"
                  @click="edit(v)"
                  >编辑</el-button
                >
                <el-divider direction="vertical"></el-divider>

                <el-button size="small" type="text" @click="del(v)"
                  >删除</el-button
                >
              </div>
            </div>
            <div class="flex flex-center mt10">
              <div
                class="flex-1 month-price"
                :class="{ monthprice: i !== month.length - 1 }"
                style="textAlign: center;"
                v-for="(j, k) in v.targetMonthModels"
                :key="k"
              >
                <div>{{ j.targetMonth }}月</div>
                <div style="fontSize:18px;marginTop:20px;" class="oneLine">
                  {{ j.targetValue }}
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      @close="close"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <el-form
        label-width="80px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="增长幅度" prop="refuseReason">
          <el-input
            style="width:140px"
            placeholder="请输入增长幅度"
            size="small"
            clearable
            :disabled="!ruleForm.targetMonthModels.length"
            @input="filterGt0OrFixed0('ruleForm', 'refuseReason')"
            v-model="ruleForm.refuseReason"
            @blur="amplitude(ruleForm.refuseReason)"
          ></el-input>
          %
        </el-form-item>
        <!-- <el-form-item label="选择年份" prop="refuseReason">
          <el-select
            size="small"
            v-model="ruleForm.specId"
            filterable
            class="mr10"
            clearable
            placeholder="请选择选择年份"
          >
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in yearList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="选择年份" prop="targetYear">
          <el-date-picker
            type="year"
            value-format="yyyy"
            :clearable="false"
            :editable="false"
            :picker-options="pickerOptions"
            v-model="ruleForm.targetYear"
            placeholder="请选择年份"
            size="small"
            @change="yearChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="选择机构"
          prop="orgCode"
          v-if="searchCondition.targetType !== 'year'"
        >
          <el-cascader
            ref="cascader"
            v-model="ruleForm.orgCode"
            :props="props"
            :show-all-levels="false"
            size="small"
            @change="orgCodeChange"
            placeholder="请选择机构"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="选择导购"
          prop="employeeId"
          v-if="employeeIdList.length"
        >
          <el-select
            size="small"
            clearable
            v-model="ruleForm.employeeId"
            @change="employeeChange"
            filterable
            class="mr10"
            placeholder="请选择导购"
          >
            <el-option
              :label="item.realname"
              :value="item.employeeId"
              v-for="(item, index) in employeeIdList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.targetMonthModels.length"
          prop="targetMonthModels"
        >
          <div class="table-bd">
            <el-table
              stripe
              ref="table"
              :data="ruleForm.targetMonthModels"
              style="width: 100%"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                label="全年"
                prop="targetMonth"
              >
                <template slot-scope="scope">
                  {{ scope.row.targetMonth + "月" }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="lastTargetValue"
                :label="ruleForm.targetYear - 1 + '年(上一年度)'"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="targetValue"
                :label="ruleForm.targetYear + '年'"
              >
                <template slot-scope="scope">
                  <el-input
                    clearable
                    v-if="searchCondition.targetMode === 'sale_amount'"
                    @input="filterGt0OrFixed2('targetValue', scope.$index)"
                    style="width: 100px"
                    v-model.trim="scope.row.targetValue"
                    size="small"
                    class="ipt mr10"
                  ></el-input>
                  <el-input
                    clearable
                    v-if="searchCondition.targetMode === 'new_member'"
                    @input="filterGt0OrFixed00('targetValue', scope.$index)"
                    style="width: 100px"
                    v-model.trim="scope.row.targetValue"
                    size="small"
                    class="ipt mr10"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitForm('ruleForm')" size="small" type="primary"
          >确认</el-button
        >
        <el-button @click="close" size="small">取消</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    const validatorFunc = (rule, val, callback) => {
      if (this.searchCondition.targetType === "emp") {
        if (this.employeeIdList.length === 0) {
          return callback(new Error("该机构下暂无导购！"));
        }
      }

      callback();
    };
    const validatorFuncMonth = (rule, val, callback) => {
      let flag = false;
      this.ruleForm.targetMonthModels.forEach(v => {
        if (v.targetValue === "") {
          flag = true;
        }
      });
      if (flag) {
        return callback(new Error("请填写完业绩目标！"));
      }
      callback();
    };
    return {
      employeeIdList: [],
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store"
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "store"
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      auditState: "all",
      state: "year",
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      yearList: [],
      title: "",
      searchCondition: {
        targetMode: "sale_amount",
        targetType: "year",
        empOrgCode: ""
      },
      dialogVisible: false,
      ruleForm: {
        refuseReason: "",
        targetId: "",
        targetYear: "",
        employeeId: "",
        orgCode: "",
        id: "",
        targetMonthModels: []
      },
      rules: {
        employeeId: {
          required: true,
          message: "请选择导购",
          trigger: "blur"
        },
        targetYear: {
          required: true,
          message: "请选择年份",
          trigger: "blur"
        },
        orgCode: [
          {
            required: true,
            message: "请选择机构",
            trigger: "change"
          },
          {
            required: true,
            validator: validatorFunc,
            trigger: "blur"
          }
        ],
        targetMonthModels: [
          {
            required: true,
            validator: validatorFuncMonth,
            trigger: "blur"
          }
        ],
        status: {
          required: true
        }
      },
      tYear: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      type: "",
      employeeIdAllList: []
    };
  },
  computed: {},
  watch: {},
  created() {
    let myDate = new Date();
    this.tYear = myDate.getFullYear();
    for (let i = 1; i < 10; i++) {
      this.yearList.push({
        value: this.tYear + i,
        label: this.tYear + i + "年"
      });
    }
  },
  mounted() {
    this.queryList();
    this.$store
      .dispatch("queryEmployee", {
        pageNo: 1,
        pageSize: 9999,
        loginType: "store",
        workingState: "yes"
      })
      .then(res => {
        this.employeeIdAllList = res.result.records;
      });
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (this.searchCondition.targetType === "depart") {
        searchCondition.targetId = this.isArray(searchCondition.targetId)
          ? searchCondition.targetId[searchCondition.targetId.length - 1]
          : "";
        searchCondition.empOrgCode = "";
      } else if (this.searchCondition.targetType === "emp") {
        searchCondition.empOrgCode = this.isArray(searchCondition.empOrgCode)
          ? searchCondition.empOrgCode[searchCondition.empOrgCode.length - 1]
          : "";
      } else if (this.searchCondition.targetType === "year") {
        searchCondition.empOrgCode = "";
      }

      Object.assign(params, searchCondition);

      const { result } = await this.$store.dispatch(
        "queryStoreSaleTargetList",
        params
      );
      result.records.forEach(v => {
        v.totalPrice = 0;
        v.targetMonthModels.forEach(j => {
          v.totalPrice = v.totalPrice + new Number(j.targetValue * 1);
          if (this.searchCondition.targetMode === "sale_amount") {
            j.targetValue = new Number(j.targetValue).toFixed(2);
          }
        });
        v.totalPrice = (v.totalPrice / 10000).toFixed(4);
      });
      this.list = result.records;
      this.total = result.total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    amplitude(val) {
      if (val !== "") {
        if (this.searchCondition.targetMode === "sale_amount") {
          this.ruleForm.targetMonthModels.forEach(v => {
            v.targetValue = (v.lastTargetValue * (1 + val / 100)).toFixed(2);
          });
        } else {
          this.ruleForm.targetMonthModels.forEach(v => {
            v.targetValue = Math.ceil(v.lastTargetValue * (1 + val / 100));
          });
        }
      }
    },
    queryLastYear() {
      let params = JSON.parse(JSON.stringify(this.ruleForm));
      if (this.ruleForm.targetYear !== "") {
        if (this.searchCondition.targetType === "year") {
          params.targetId = this.ruleForm.targetYear;
          this.getByTargetId(params);
        } else if (this.searchCondition.targetType === "depart") {
          if (this.isArray(this.ruleForm.orgCode)) {
            params.orgCode = this.ruleForm.orgCode[
              this.ruleForm.orgCode.length - 1
            ];
            params.targetId = this.ruleForm.orgCode[
              this.ruleForm.orgCode.length - 1
            ];
            this.getByTargetId(params);
          }
        } else if (this.searchCondition.targetType === "emp") {
          if (
            this.isArray(this.ruleForm.orgCode) &&
            this.ruleForm.employeeId !== ""
          ) {
            params.targetId = this.ruleForm.employeeId;
            params.orgCode = this.ruleForm.orgCode[
              this.ruleForm.orgCode.length - 1
            ];
            this.getByTargetId(params);
          }
        }
      }
    },
    async getByTargetId(params) {
      Object.assign(params, this.searchCondition);
      const { result } = await this.$store.dispatch("getByTargetId", params);

      if (result === null) {
        this.ruleForm.targetMonthModels.forEach(v => {
          v.lastTargetValue = 0;
        });
      } else {
        this.ruleForm.targetMonthModels.forEach(v => {
          result.targetMonthModels.forEach(j => {
            if (v.targetMonth === j.targetMonth) {
              v.lastTargetValue = j.targetValue;
            }
          });
        });
      }
      this.ruleForm.targetMonthModels = [...this.ruleForm.targetMonthModels];
      this.amplitude(this.ruleForm.refuseReason);
    },
    queryMonth() {
      this.ruleForm.targetMonthModels = [];
      for (let i = 1; i <= 12; i++) {
        if (i < 10) {
          this.ruleForm.targetMonthModels.push({
            targetMonth: "0" + i,
            targetValue: ""
          });
        } else {
          this.ruleForm.targetMonthModels.push({
            targetMonth: i + "",
            targetValue: ""
          });
        }
      }
    },
    close() {
      this.dialogVisible = false;
      this.resetRuleForm();
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
        this.ruleForm.targetMonthModels = [];
        this.employeeIdList = [];
        this.ruleForm.refuseReason = "";
        this.ruleForm.targetId = "";
        this.ruleForm.targetYear = "";
        this.ruleForm.employeeId = "";
        this.ruleForm.orgCode = "";
        this.ruleForm.id = "";
      }, 0);
    },
    switchAuditState() {},
    switchState() {
      this.currentPage = 1;
      this.queryList();
    },
    yearChange() {
      if (this.searchCondition.targetType === "year") {
        this.queryMonth();
      }
      this.queryLastYear();
    },
    orgCodeChange(val) {
      if (this.searchCondition.targetType === "depart") {
        if (this.ruleForm.targetYear !== "") {
          this.queryMonth();
        }
      }
      if (this.searchCondition.targetType === "emp") {
        this.queryEmp(val);
      }
      this.queryLastYear();
      this.ruleForm.employeeId = "";
    },
    employeeChange() {
      if (this.ruleForm.targetYear !== "") {
        this.queryMonth();
      }
      this.queryLastYear();
    },
    async queryEmp(orgCode) {
      const { result } = await this.$store.dispatch("queryEmployee", {
        pageNo: 1,
        pageSize: 9999,
        loginType: "store",
        workingState: "yes",
        orgCode: orgCode[orgCode.length - 1]
      });
      this.employeeIdList = result.records;
      if (this.employeeIdList.length === 0) {
        this.$message({
          message: "该机构下暂无导购！",
          type: "warning"
        });
      }
    },
    add() {
      this.dialogVisible = true;
      this.title =
        this.searchCondition.targetMode === "sale_amount"
          ? "新增业绩目标配置"
          : "新增新客目标配置";
      this.type = "add";
    },
    edit(v) {
      this.dialogVisible = true;
      this.type = "edit";
      this.title =
        this.searchCondition.targetMode === "sale_amount"
          ? "编辑业绩目标配置"
          : "编辑新客目标配置";

      let row = JSON.parse(JSON.stringify(v));

      for (let key in this.ruleForm) {
        if (key !== "refuseReason") {
          this.ruleForm[key] = row[key];
        }
      }

      if (this.searchCondition.targetType === "depart") {
        this.ruleForm.orgCode = [row.targetId];
      } else if (this.searchCondition.targetType === "emp") {
        this.ruleForm.orgCode = [row.empOrgCode];
        this.queryEmp(this.ruleForm.orgCode);
        this.ruleForm.employeeId = row.targetId;
      }
      setTimeout(() => {
        if (this.$refs.cascader) {
          this.$refs.cascader.presentText = row.departName || row.empDepartName;
        }
      }, 0);
      this.queryLastYear();
    },
    async del(v) {
      this.$confirm(`是否确定删除？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = JSON.parse(JSON.stringify(v));
          params.operationType = "del";
          this.$store.dispatch("editStoreSaleTargetInfo", params).then(res => {
            if (res.code === "0") {
              this.dialogVisible = false;
              this.queryList();
              this.$message({
                message: "操作成功！",
                type: "success"
              });
            }
          });
        })
        .catch(() => {});
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = JSON.parse(JSON.stringify(this.ruleForm));
        // params.orgCode = this.isArray(params.orgCode)
        //   ? params.orgCode[params.orgCode.length - 1]
        //   : "";
        // if (this.searchCondition.targetType !== "year") {
        //   params.orgCode = params.orgCode[params.orgCode.length - 1];
        // }

        if (this.searchCondition.targetType === "year") {
          params.targetId = this.ruleForm.targetYear;
          Object.assign(params, this.searchCondition);

          let name =
            this.type === "add"
              ? "saveStoreSaleTargetInfo"
              : "editStoreSaleTargetInfo";
          if (this.type === "edit") {
            params.operationType = "edit";
          }
          const { code } = await this.$store.dispatch(name, params);
          if (code === "0") {
            this.dialogVisible = false;
            this.resetRuleForm();
            this.queryList();
            this.$message({
              message: "操作成功！",
              type: "success"
            });
          }
        } else if (this.searchCondition.targetType === "depart") {
          params.orgCode = params.orgCode[params.orgCode.length - 1];
          params.targetId = params.orgCode;
          Object.assign(params, this.searchCondition);

          let name =
            this.type === "add"
              ? "saveStoreSaleTargetInfo"
              : "editStoreSaleTargetInfo";
          if (this.type === "edit") {
            params.operationType = "edit";
          }
          const { code } = await this.$store.dispatch(name, params);
          if (code === "0") {
            this.dialogVisible = false;
            this.resetRuleForm();
            this.queryList();
            this.$message({
              message: "操作成功！",
              type: "success"
            });
          }
        } else if (this.searchCondition.targetType === "emp") {
          params.orgCode = params.orgCode[params.orgCode.length - 1];
          params.targetId = params.employeeId;
          Object.assign(params, this.searchCondition);

          let name =
            this.type === "add"
              ? "saveStoreSaleTargetInfo"
              : "editStoreSaleTargetInfo";
          if (this.type === "edit") {
            params.operationType = "edit";
          }
          const { code } = await this.$store.dispatch(name, params);
          if (code === "0") {
            this.dialogVisible = false;
            this.resetRuleForm();
            this.queryList();
            this.$message({
              message: "操作成功！",
              type: "success"
            });
          }
        }
      } else {
        return false;
      }
    },
    filterGt0OrFixed2(prop, i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.targetMonthModels[i][
        prop
      ] = this.ruleForm.targetMonthModels[i][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.targetMonthModels[i][
        prop
      ] = this.ruleForm.targetMonthModels[i][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.targetMonthModels[i][
        prop
      ] = this.ruleForm.targetMonthModels[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.targetMonthModels[i][
        prop
      ] = this.ruleForm.targetMonthModels[i][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.ruleForm.targetMonthModels[i][prop].indexOf(".") < 0 &&
        this.ruleForm.targetMonthModels[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.targetMonthModels[i][prop] = parseFloat(
          this.ruleForm.targetMonthModels[i][prop]
        );
      }
    },
    filterGt0OrFixed0(ruleForm, prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "");
    },
    filterGt0OrFixed00(prop, i) {
      // this.ruleForm.targetMonthModels[i][
      //   prop
      // ] = this.ruleForm.targetMonthModels[i][prop].replace(/^(0+)/, ""); //过滤0开头

      this.ruleForm.targetMonthModels[i][
        prop
      ] = this.ruleForm.targetMonthModels[i][prop].replace(/[^\d]+/g, "");
      this.ruleForm.targetMonthModels[i][
        prop
      ] = this.ruleForm.targetMonthModels[i][prop].replace(/\.{2,}/g, "");
    }
  }
};
</script>
<style lang="scss" scoped>
.oneLine {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table-bd {
  border: 1px solid #dddddd;
}
.results {
  .results-header {
    width: 150px;
    // height: 150px;
    background: rgba(0, 129, 229, 1);
    padding: 30px;
    .results-title {
      color: aliceblue;
      font-size: 17px;
      line-height: 16px;
      height: 33px;
      // margin-top: 49px;
    }
    .results-task {
      color: aliceblue;
      text-align: center;
      // margin-top: 20px;
      .results-price {
        font-size: 30px;
        line-height: 30px;
      }
    }
  }
  .results-month {
    padding: 15px;
    .title {
      font-size: 16px;
      line-height: 16px;
      height: 20px;
      font-weight: 600;
      // margin-bottom: 20px;
      &::before {
        display: inline-block;
        // margin-right: 10px;
        content: "";
        width: 4px;
        height: 12px;
        background: #e50065;
        border-top-left-radius: 30px;
        border-bottom-right-radius: 30px;
      }
    }
    .monthprice {
      border-right: 1px solid #dddddd;
    }
  }
}
</style>
